<template>
  <div class="player-container" ref="playerContainer">
    <div v-if="iOS" class="button-controls" ref="buttonControls">
      <v-btn class="play-btn" large fab @click="onPlayBtnClicked">
        <v-icon v-if="isVideoPlaying">fas fa-pause</v-icon>
        <v-icon v-else>fas fa-play</v-icon>
      </v-btn>
    </div>
    <iframe
      v-resize="adjustPlayerDimenions"
      frameborder="0"
      ref="video-iframe"
      width="100%"
      :height="height"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      :src="videoSrc"
    ></iframe>
  </div>
</template>

<script>
import Player from "@vimeo/player";
export default {
  props: {
    videoId: {
      required: true,
    },
  },

  data() {
    return {
      height: "100%",
      player: null,
      videoRatio: null,
      videoError: null,
      isVideoPlaying: false,
    };
  },

  mounted() {
    console.log("mounted", this.videoId, this.$refs);
    const videoEl = this.$refs["video-iframe"];
    if (videoEl) {
      this.player = new Player(videoEl);
      this.player.setVolume(0.001);
      this.adjustPlayerDimenions();
    }
  },

  computed: {
    videoSrc() {
      let url = `https://player.vimeo.com/video/${this.videoId}?title=0&byline=0&portrait=0&dnt=1&muted=1&autoplay=0`;
      if (this.iOS) url += "&background=1";

      return url;
    },

    iOS() {
      return (
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      );
    },
  },

  methods: {
    async adjustPlayerDimenions() {
      this.videoError = null;

      const videoEl = this.$refs["video-iframe"];

      if (!this.player || !videoEl) return;

      const containerWidth = videoEl.clientWidth;

      if (!this.videoRatio) {
        console.log("Fetch video ratio");
        try {
          const values = await Promise.all([
            this.player.getVideoHeight(),
            this.player.getVideoWidth(),
          ]);
          this.videoRatio = values[1] / values[0];
        } catch (error) {
          this.videoError = error.message;
        }
      }

      if (this.videoRatio) {
        this.height = `${containerWidth / this.videoRatio}px`;
      }
    },
    async onPlayBtnClicked() {
      console.log("onPlayBtnClicked");
      if (this.player) {
        const isPaused = await this.player.getPaused();
        console.log({ isPaused });
        if (isPaused) {
          this.player.play();
          this.isVideoPlaying = true;
        } else {
          this.player.pause();
          this.isVideoPlaying = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.player-container {
  position: relative;

  .button-controls {
    display: none;
  }

  &:hover {
    .button-controls {
      display: block;
    }
  }
  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: white;
    background-color: rgba(0, 0, 0, 0.4) !important;
  }
}
</style>
